// component
import InventoryIcon from '@mui/icons-material/Inventory';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import HistoryIcon from '@mui/icons-material/History';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ArchiveIcon from '@mui/icons-material/Archive';
import MoveUpOutlinedIcon from '@mui/icons-material/MoveUpOutlined';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import SimCardIcon from '@mui/icons-material/SimCard';
import { api as authApi } from '../store/domains/auth';
import Iconify from '../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;
export const allMenu = [
  {
    title: 'Dealer',
    path: '/dashboard/dealer',
    icon: getIcon('eva:people-fill'),
    type: 'DEALER_MODULE',
  },
  {
    title: 'Start pack',
    path: '/dashboard/start-pack',
    icon: <InventoryIcon />,
    type: 'STARTER_PACK_MODULE',
  },
  {
    title: 'Dealer Management',
    path: '/dashboard/dealer-management',
    icon: <CorporateFareIcon />,
    type: 'DEALER_CREATE_MODULE',
  },
  {
    title: 'SO mapping',
    path: '/dashboard/so-mapping',
    icon: <LocalOfferIcon />,
    type: 'DEALER_CREATE_MODULE',
  },
  {
    title: 'SIM Swap',
    path: '/dashboard/sim-swap',
    icon: <SwapHorizIcon />,
    type: 'DEALER_CREATE_MODULE',
  },
  {
    title: 'Access management',
    path: '/dashboard/access-management',
    icon: <VpnKeyIcon />,
    type: 'ADVANCED_FEATURE_MODULE',
  },
  {
    title: 'FIN Whitelist',
    path: '/dashboard/whitelist',
    icon: <PlaylistAddCheckIcon />,
    type: 'DEALER_CREATE_MODULE',
  },
  {
    title: 'İccid History',
    path: '/dashboard/iccid-history',
    icon: <AssessmentIcon />,
    type: 'ICCID_HISTORY_MODULE',
  },
  {
    title: 'Iccid',
    path: '/dashboard/iccid',
    icon: <ConfirmationNumberIcon />,
    type: 'ICCID_MODULE',
  },
  {
    title: 'Iccid organization',
    path: '/dashboard/iccid-organization',
    icon: <SimCardIcon />,
    type: 'ICCID_MODULE',
  },
  {
    title: 'Number discovery',
    path: '/dashboard/number-discovery',
    icon: <FormatListNumberedIcon />,
    type: 'NUMBER_DISCOVERY_MODULE',
  },
  {
    title: 'History',
    path: '/dashboard/history',
    icon: <HistoryIcon />,
    type: 'STOCK_HISTORY_MODULE',
  },
  { title: 'Hierarchy', path: '/dashboard/hierarchy', icon: <AccountTreeIcon />, type: 'HIERARCHY_MODULE' },
  { title: 'Sales history', path: '/dashboard/dealer-archive', icon: <ArchiveIcon />, type: 'SALES_HISTORY_MODULE' },
  {
    title: 'Transfer ownership',
    path: '/dashboard/transfer-ownership',
    icon: <MoveUpOutlinedIcon />,
    type: 'TRANSFER_OWNERSHIP_HISTORY',
  },
];
const useMenuList = () => {
  const { data, isLoading } = authApi.useGetMe();

  // return isLoading ? [] : allMenu.map((item) => item);
  return isLoading ? [] : allMenu.filter((item) => data?.acceptedModules.includes(item.type));
};

export default useMenuList;
